<template>
  <div class="overflow: auto">
    <div class="query-c">
      <DatePicker
        type="daterange"
        split-panels
        placeholder="按时间查询"
        style="width: 200px;margin-left:20px"
        @on-change="queryTime"
      ></DatePicker>
    </div>
    <br />
    <Tabs value="name1">
      <TabPane :label="'黑牛保险('+total+')条'" name="name1">
        <Table :content="self" border stripe :columns="columns1" :data="data1"></Table>
      </TabPane>
    </Tabs>

    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Insurance",

  data() {
    return {
      pageNow: 1,
        self: this,
      total: 0,
      time: [],
      columns1: [
        {
          title: "产品详情",
          align: "center",
          key: "info"
        },
        {
          title: "保险有效期",
          align: "center",
          key: "policyValidity"
        },
        {
          title: "实际承保的产品代码",
          align: "center",
          key: "code"
        },
        {
          title: "投保人姓名",
          align: "center",
          key: "name"
        },
        {
          title: "黑牛结果页回调url",
          align: "center",
          key: "url"
        },
        {
          title: "保险公司名称",
          align: "center",
          key: "company"
        },
        {
          title: "产品名称",
          align: "center",
          key: "detail"
        },
        {
          title: "消息",
          align: "center",
          key: "errorMsg"
        },
        {
          title: "保单号",
          align: "center",
          key: "policyNo"
        }
      ],
      data1: []
    };
  },

  activated: function() {
    this.getData("");
  },
  mounted: function() {
    this.getData("");
  },
  methods: {
    getData() {
      api
        .GetAddHeiniuxian({
          start: this.time[0],
          end: this.time[1],
          pageNow: this.pageNow,
          pageSize: "10"
        })
        .then(res => {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
        });
    },
    changeInput() {
          this.pageNow = 0;
      this.getData();
    },

    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000+86400000 ;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>